import { create } from "zustand";
import { clearJwt, getJwt, setJwt } from "@/lib/api";

type AuthState = {
  address: string | null;
  chainId: number | null;
  isAuthed: () => boolean;
  signIn: (token: string, address: string, chainId: number) => void;
  signOut: () => void;
};

function initFromJwt(): { address: string | null; chainId: number | null } {
  const t = getJwt();
  if (!t) return { address: null, chainId: null };
  try {
    const payloadB64 = t.split(".")[1];
    if (!payloadB64) return { address: null, chainId: null };
    const decoded = JSON.parse(atob(payloadB64.replace(/-/g, "+").replace(/_/g, "/")));
    if (decoded.exp && decoded.exp < Math.floor(Date.now() / 1000)) {
      clearJwt();
      return { address: null, chainId: null };
    }
    return { address: decoded.sub ?? null, chainId: decoded.chainId ?? null };
  } catch {
    clearJwt();
    return { address: null, chainId: null };
  }
}

const initial = initFromJwt();

export const useAuthStore = create<AuthState>((set, get) => ({
  address: initial.address,
  chainId: initial.chainId,
  isAuthed: () => !!get().address,
  signIn: (token, address, chainId) => {
    setJwt(token);
    set({ address, chainId });
  },
  signOut: () => {
    clearJwt();
    set({ address: null, chainId: null });
  },
}));
